// Recovered compiled webpack factory 62032. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "parseUrl", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(33078),
    a = r(40579);
  function o(e) {
    if (e.startsWith("/")) return (0, a.parseRelativeUrl)(e);
    let t = new URL(e);
    return {
      hash: t.hash,
      hostname: t.hostname,
      href: t.href,
      pathname: t.pathname,
      port: t.port,
      protocol: t.protocol,
      query: (0, n.searchParamsToUrlQuery)(t.searchParams),
      search: t.search,
      slashes: "//" === t.href.slice(t.protocol.length, t.protocol.length + 2),
    };
  }
}
